market = {};
market.init = function () {
	market.user.init();
	market.category.init();
	market.discussion.search.init();
	market.discussion.bookmark.init();
	market.whisper.init();
	market.attachment.init();
	market.preview.init();
};
market.isMobile = function () {
	return $(window).width() < 767
};
// User search
market.user = {};
market.user.init = function () {
	$('.username-search').autocomplete({
		source: '/_/' + moya.division + '/market/json/username',
		minLength: 3
	});
};
// Category sort
market.category = {};
market.category.forSale = null;
market.category.init = function () {
	var $categorySort = $('#category-sort');
	$categorySort.sortable();
	$('#category-sort-save').click(function () {
		var $button = $(this);
		$.post($(this).attr('href'), $categorySort.sortable('serialize'), function (response) {
			if (response.success) {
				window.location.replace($button.attr('rel'));
			} else {
				alert(response.message);
			}
		}, 'json');

		return false;
	});
	$('select.price-toggle').change(function () {
		$('.price-input').toggleClass('hidden', $(this).val() != market.category.forSale);
	}).trigger('change');
};

// Discussion search
market.discussion = {};
market.discussion.search = {};
market.discussion.search.init = function () {
	$('.discussion-search .filters input, .discussion-search select').change(function () {
		$('.discussion-search').submit();
	});
	market.discussion.search.toggleSortAndSale($('.discussion-search-category'));
};
market.discussion.search.toggleSortAndSale = function ($element) {
	$.each($element, function () {
		$(this).parent().toggleClass('selected', $(this).is(':checked'));
	})
};

market.discussion.bookmark = {};
market.discussion.bookmark.success = 'Bookmark saved';
market.discussion.bookmark.init = function () {
	$('.bookmark-add').click(function () {
		var $link = $(this);
		if(!$link.hasClass('bookmarked')) {
			$.get($link.attr('href'), function (response) {
				if(response.success) {
					$link.addClass('bookmarked');
					moya.message.add(market.discussion.bookmark.success, 'success');
				}
			}, 'json');
		}

		return false;
	});
};

// Pop-up window for whispers between users
market.whisper = {};
market.whisper.dialog = {};
market.whisper.dialog.title = 'Send whisper';
market.whisper.dialog.buttonTitle = 'Send whisper';
market.whisper.init = function () {
	var $dialog = $('div.whisper-dialog').dialog({
		modal: true,
		autoOpen: false,
		height: 400,
		width: 400,
		dialogClass: 'market-dialog',
		title: market.whisper.dialog.title,
		open: function () {
			var $sendButton = $('#whisper-send-button');
			$dialog.html('<i class="fa fa-spinner fa-spin fa-3x"></i>');
			$.get($dialog.data('form-action'), function (data) {
				$dialog.html(data.form);
				var $form = $dialog.find('form');
				$form.find('#username').val();
				$sendButton.button('enable');
			},'json');
		},
		buttons: [{
			id: 'whisper-send-button',
			text: market.whisper.dialog.buttonTitle,
			click: function() {
				var $sendButton = $('#whisper-send-button');
				$sendButton.button('disable');
				var $form = $dialog.find('form');
				$form.ajaxForm({
					dataType: 'json',
					success: function (data) {
						if(data.success) {
							$sendButton.effect('highlight', {color: 'green'}, 1000, function () {
								$dialog.dialog('close');
							});
						}
						else {
							$form.replaceWith(data.form);
							$sendButton.button('enable');
						}
					}
				});
				$form.submit();
				return false;
			}
		}]
	});

	var $triggers = $('a.whisper-dialog-open');
	$triggers.click(function () {
		$dialog.data('form-action', $(this).attr('href'));
		$dialog.dialog('option', 'position', {my: 'right-20 top', at: 'left top', of: $(this)});
		$dialog.dialog('open');
		return false;
	});
};
// Attachments. Images used for discussions and comments
market.attachment = {};
market.attachment.max = 3;
market.attachment.next = 1;
market.attachment.init = function () {
	$('.attachment-add').click(function () {
		market.attachment.add();
		return false;
	});
};
market.attachment.addDeleteButton = function ($element) {
	var $deleteButton = $('<a>')
		.attr('class', 'attachment-delete')
		.attr('href', 'javascript:void(0)')
		.attr('onclick', 'this.parentNode.parentNode.removeChild(this.parentNode);')
		.html('[ - ]');
	$element.find('span.lmnt').after($deleteButton);
};
market.attachment.add = function () {
	if ($('.attachment').length <= market.attachment.max) {
		var $list = $('.attachment-list-new');
		var $template = $list.find('.attachment-template');

		var $clone = $template.clone(true);
		var $input = $clone.find('input');
		var next = market.attachment.next;
		$clone.removeClass('attachment-template');
		$clone.attr('id', 'elm_attachment_' + next);
		$input.attr('id', 'attachment_' + next);
		$input.attr('name', 'attachment_' + next);
		market.attachment.addDeleteButton($clone);
		$list.append($clone);
		market.attachment.next += 1;
	}
};

// Image preview for discussion and commments
market.preview = {};
market.preview.xOffset = 10;
market.preview.yOffset = 30;
market.preview.$container = null;
market.preview.containerId = 'market-preview';
market.preview.init = function () {
	var $triggers = $('a.preview');
	var $container;

	$triggers.hover(function (e) {
		if (!market.isMobile()) {
			var elm = this;
			elm.t = elm.title;
			elm.title = "";
			var c = (elm.t != "") ? "<br/>" + elm.t : "";
			$('body').append("<p id='" + market.preview.containerId + "'><img src='" + elm.rel + "' alt='Image preview' />" + c + "</p>");
			$container = $('#market-preview');
			$container
				.css('top', (e.pageY - market.preview.xOffset) + "px")
				.css('left', (e.pageX + market.preview.yOffset) + "px")
				.fadeIn('fast');
		}
	}, function () {
		if (!market.isMobile()) {
			var elm = this;
			elm.title = elm.t;
			$container.remove();
		}
	});

	$triggers.mousemove(function (e) {
		if (!market.isMobile()) {
			$container
				.css('top', (e.pageY - market.preview.xOffset) + "px")
				.css('left', (e.pageX + market.preview.yOffset) + "px");
		}
	});
};